import React from "react";
import { Button } from "react-bootstrap";
import { adminReportList } from "../../data";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { reqToUpdateReportList } from "../../store/slice/reportSlice";

const AdminPortal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleChangeCallType = (item) => {
    dispatch(reqToUpdateReportList([]));
    if(item?.route === "/admin/fts-report"){
      navigate(item?.route, {
        state: {
          ...item,
          title: item?.title,
          reportType: item?.value,
        },
      });
    }
  };

  return (
    <div className="d-flex m-auto flex-column justify-content-center gap-3 min-width-300">
      {Array.isArray(adminReportList) &&
        adminReportList.map((item, i) => {
          if (item?.isActive) {
            return (
              <Button
                key={i}
                type="button"
                variant="green-gradient"
                disabled={item?.value !== "FTS"}
                onClick={() => handleChangeCallType(item)}
              >
                {item.label}
              </Button>
            );
          } else {
            return null;
          }
        })}
    </div>
  );
};

export default AdminPortal;
